export const clickableGridRows = (e, clickAction) => {
  const grid = e.sender;
  const rows = $(grid.element).find('table[role="grid"] tbody tr[role="row"]');
  rows.unbind('click');
  rows.on('click', clickAction);
  rows.css('cursor', 'pointer');
};